import { render, staticRenderFns } from "./r-item-dragon-config.vue?vue&type=template&id=f9746e50"
import script from "./r-item-dragon-config.vue?vue&type=script&lang=js"
export * from "./r-item-dragon-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9746e50')) {
      api.createRecord('f9746e50', component.options)
    } else {
      api.reload('f9746e50', component.options)
    }
    module.hot.accept("./r-item-dragon-config.vue?vue&type=template&id=f9746e50", function () {
      api.rerender('f9746e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/dragon/r-item-dragon-config.vue"
export default component.exports